import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { PAYMENT_STATUS } from 'domains/customer-order/constants'

const propTypes = {
  status: PropTypes.string
}

/**
 * @param {string} status
 */
const CustomerOrderPaymentStatusBadge = ({ status }) => {

  const colorMap = {
    [PAYMENT_STATUS.PENDING]            : 'warning',
    [PAYMENT_STATUS.PENDING_SETTLEMENT] : 'info',
    [PAYMENT_STATUS.COMPLETED]          : 'success',
    [PAYMENT_STATUS.FAILED]             : 'danger',
    [PAYMENT_STATUS.EXPIRED]            : 'danger',
    [PAYMENT_STATUS.CANCELLED]          : 'danger'
  }

  const color = colorMap[status] || 'default'

  return <StatusBadge color={ color } label={ status } />
}

CustomerOrderPaymentStatusBadge.propTypes = propTypes

export default CustomerOrderPaymentStatusBadge